import { gql } from '@apollo/client'

export const validateCoursePurchase = gql`
  query ValidateCoursePurchase($courseId: String!, $sessionId: String!) {
    validateCoursePurchase(courseId: $courseId, sessionId: $sessionId)
  }
`
